<template>
  <el-dialog
    title="添加广告"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        prop="title"
        label="广告标题"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item
        prop="target_delivery"
        label="投放对象"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <div  v-if="false">  <el-input v-model="form.target_delivery"></el-input></div>
        <el-row>
        <el-button @click="showToggle(1)" v-if="CC1"  >商户</el-button>
          <el-button @click="showToggle(1)" v-if="CC4"  type="primary" >商户</el-button>
        <el-button @click="showToggle(2)" v-if="CC2" >客户</el-button>
          <el-button @click="showToggle(2)" v-if="CC5"  type="primary">客户</el-button>
        <el-button @click="showToggle(3)"  v-if="CC3" >付款设备</el-button>
          <el-button @click="showToggle(3)" v-if="CC6"   type="primary">付款设备</el-button>






        </el-row>
      </el-form-item>
      <el-form-item
        prop="delivery_scope"
        label="投放范围"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <div  v-if="false"> <el-input v-model="form.delivery_scope"></el-input></div>
        <el-row>
        <div  v-if="typeone">

        <el-button @click="showToggle2(4)" v-if="BB4">所有商户</el-button>
          <el-button @click="showToggle2(4)" v-if="BB104" type="primary">所有商户</el-button>
        <el-button @click="showToggle2(5)" v-if="BB5">选择城市</el-button>
          <el-button @click="showToggle2(5)" v-if="BB105"  type="primary">选择城市</el-button>
        <el-button @click="showToggle2(6)" v-if="BB6">商户收款后页面</el-button>
          <el-button @click="showToggle2(6)" v-if="BB106"  type="primary">商户收款后页面</el-button>
        </div>
        <div  v-if="typetwo">
        <el-button @click="showToggle2(7)" v-if="BB7">客户小程序</el-button>
          <el-button @click="showToggle2(7)" v-if="BB107" type="primary">客户小程序</el-button>
        <el-button @click="showToggle2(8)" v-if="BB8">客户付完款页面</el-button>
          <el-button @click="showToggle2(8)" v-if="BB108"  type="primary">客户付完款页面</el-button>
        </div>
        <div  v-if="typethree">
        <el-button @click="showToggle2(9)"  v-if="BB9">启动页</el-button>
          <el-button @click="showToggle2(9)"  v-if="BB109"  type="primary">启动页</el-button>
        <el-button @click="showToggle2(10)" v-if="BB10">收银页</el-button>
          <el-button @click="showToggle2(10)" v-if="BB110"  type="primary">收银页</el-button>
        <el-button @click="showToggle2(11)" v-if="BB11">支付成功页</el-button>
          <el-button @click="showToggle2(11)" v-if="BB111"  type="primary">支付成功页</el-button>
        <el-button @click="showToggle2(12)" v-if="BB12">收押金成功页</el-button>
          <el-button @click="showToggle2(12)" v-if="BB112"  type="primary">收押金成功页</el-button>
        <el-button @click="showToggle2(13)" v-if="BB13">退押金成功页</el-button>
          <el-button @click="showToggle2(13)" v-if="BB113"  type="primary">退押金成功页</el-button>
        </div>
        </el-row>
      </el-form-item>
      <el-form-item
        prop="defaultposter"
        label="设为默认广告"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-radio v-model="form.defaultposter" label="1">设为默认</el-radio>
      </el-form-item>
      <el-form-item
              prop="industry_classification"
              label="行业分类"
              v-if="typegg"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-checkbox-group v-model="form.industry_classification">
          <el-checkbox label="超市"></el-checkbox>
          <el-checkbox label="自助点餐"></el-checkbox>
          <el-checkbox label="医药"></el-checkbox>
          <el-checkbox label="加油站"></el-checkbox>
          <el-checkbox label="景区"></el-checkbox>
          <el-checkbox label="酒店"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item
              prop="city"
              label="投放城市"
              v-if="tfcs"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择省"
                @change="currentSel(form.prov_cd)"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>

        <el-select
                class="filter-item"
                v-model="form.city"
                placeholder="请选择市"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>


      <el-form-item
              v-if="typemt"
              prop="media_type"
              label="媒体类型"

      >
        <el-radio v-model="form.media_type" label="1"  @change="changeHandler(1)">图片广告</el-radio>
        <el-radio v-model="form.media_type" label="2" @change="changeHandler(2)">视频广告</el-radio>
      </el-form-item>

      <el-form-item   :label="imgtitle" prop="picture" v-if="TB1"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.picture" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
        <div  v-if="cc1">建议尺寸：宽750*高220</div>
        <div  v-if="cc2">建议尺寸：宽800*高1280</div>
        <div  v-if="cc3">建议尺寸：宽800*高600</div>
      </el-form-item>


      <el-form-item   label="视频" prop="picture"  v-if="TB2" :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.picture" style="display:none"></el-input>
        <el-upload class="avatar-uploader"
                   :action="videoUrl"
                   v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                   v-bind:on-progress="uploadVideoProcess"
                   v-bind:on-success="handleVideoSuccess"
                   v-bind:before-upload="beforeUploadVideo"
                   v-bind:show-file-list="true">
          <video v-if="form.showVideoPath !='' && !videoFlag"
                 v-bind:src="form.showVideoPath"
                 class="avatar video-avatar"
                 controls="controls"  style="width: 500px;height: 500px; ">
            您的浏览器不支持视频播放
          </video>
          <i v-else-if="form.showVideoPath =='' && !videoFlag"
             class="el-icon-plus avatar-uploader-icon"></i>
          <el-progress v-if="videoFlag == true"
                       type="circle"
                       v-bind:percentage="videoUploadPercent"
                       style="margin-top:7px;"></el-progress>
        </el-upload>
        <div  v-if="cc1">最多可以上传1个视频，建议大小10M，推荐格式mp4</div>
      </el-form-item>

      <el-form-item
              prop="open_browser"
              label="使用外部浏览器打开"
      >
        <el-radio v-model="form.open_browser" label="1">是</el-radio>
        <el-radio v-model="form.open_browser" label="2">否</el-radio>
      </el-form-item>
      <el-form-item
              prop="screen"
              label="设备屏幕"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.screen"
                placeholder="设备屏幕"
                width="50"
        >
          <el-option
                  v-for="item in stateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="img_url"
              v-if="typetplj"
              label="图片链接"
      >
        <el-input v-model="form.img_url"></el-input>
      </el-form-item>
      <el-form-item
              prop="dateRange"
              label="有效日期"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-date-picker
                v-model="form.dateRange"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"    width="150">

        </el-date-picker>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>
  .class-a {
    background-color: #0ABBF9;
    border-color: #0ABBF9;
  }
</style>

<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        TB2:false,
        TB1:true,
        CC1: true,
        CC2:true,
        CC3:true,
        CC4: false,
        CC5:false,
        CC6:false,
        BB1:true,
        BB2:true,
        BB3:true,
        BB4:true,
        BB5:true,
        BB6:true,
        BB7:true,
        BB8:true,
        BB9:true,
        BB10:true,
        BB11:true,
        BB12:true,
        BB13:true,
        BB101:false,
        BB102:false,
        BB103:false,
        BB104:false,
        BB105:false,
        BB106:false,
        BB107:false,
        BB108:false,
        BB109:false,
        BB110:false,
        BB111:false,
        BB112:false,
        BB113:false,




        typeOptions: [],
        typeOptions2: [],
        stateOptions: [
            {
                value: "0",
                label: "横屏"
            },
            {
                value: "1",
                label: "竖屏"
            }
        ],
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        videoUrl: process.env.VUE_APP_API+"/moblieapp/videoUpload",
        fileList: [],
        formEdit: true,
        cc1:true,
        cc2:false,
        cc3:false,
        tfcs:false,
        typeone: false,
        typetwo: false,
        typethree: false,
        typemt:false,
        typegg:true,
      loading: false,
      dialogVisible: false,
        typetplj:true,
        dialogImageUrl: '',
        pickerOptions:{},
        imgtitle:'展示图片',
        videoFlag: false,
        //是否显示进度条
        videoUploadPercent: "",
        //进度条的进度，
        isShowUploadVideo: false,
      form: {
          industry_classification:[],
          showVideoPath: '',
          outsideie:"1",
          media_type:"1",
          picture:"",
          open_browser:"",
          dateRange: []
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();

        var formData2 = new FormData() // 声明一个FormData对象
        agentService.getProvcd(formData2).then(data => {
            this.typeOptions=data;
        });
        console.info("this.oneclass.city"+this.oneclass.city);
        console.info("this.oneclass.prov_cd"+this.oneclass.prov_cd);
        if(this.oneclass.city!=null && this.oneclass.city!="") {
            if (this.oneclass.city) {
                this.currentSel(this.oneclass.prov_cd);
            }
        }


        this.CC1=true,
            this.CC2=true;
        this.CC3=true;
        this.CC4=false;
        this.CC5=false;
        this.CC6=false;
        this.BB1=true;
        this.BB2=true;
        this.BB3=true;
        this.BB4=true;
        this.BB5=true;
        this.BB6=true;
        this.BB7=true;
        this.BB8=true;
        this.BB9=true;
        this.BB10=true;
        this.BB11=true;
        this.BB12=true;
        this.BB13=true;
        this.BB101=false;
        this.BB102=false;
        this.BB103=false;
        this.BB104=false;
        this.BB105=false;
        this.BB106=false;
        this.BB107=false;
        this.BB108=false;
        this.BB109=false;
        this.BB110=false;
        this.BB111=false;
        this.BB112=false;
        this.BB113=false;
        this.tfcs=false;
      if (this.oneclass.id) {
          let form = {};
          form.title=this.oneclass.title;
          form.target_delivery=this.oneclass.target_delivery;

          if(this.oneclass.prov_cd!=null && this.oneclass.prov_cd!=""){
          form.prov_cd = this.oneclass.prov_cd;
          }
          if(this.oneclass.city!=null && this.oneclass.city!="") {
              form.city = this.oneclass.city;
          }
          if(this.oneclass.target_delivery==1){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.typetplj=true;
              this.typeone = true;
              this.typetwo = false;
              this.typethree = false;
              this.typegg=true;

              this.CC1=false;
              this.CC2=true;
              this.CC3=true;
              this.CC4= true;
              this.CC5=false;
              this.CC6=false;

          }else if(this.oneclass.target_delivery==2){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.typetplj=true;
              this.typetwo = true;
              this.typeone = false;
              this.typethree = false;
              this.typegg=false;

              this.CC1=true;
              this.CC2=false;
              this.CC3=true;
              this.CC4= false;
              this.CC5=true;
              this.CC6=false;
          }else if(this.oneclass.target_delivery==3){
              this.TB1=true;
              this.TB2=false;
              this.typetplj=false;
              this.typethree = true;
              this.typetwo = false;
              this.typeone = false;
              this.typegg=true;

              this.CC1=true;
              this.CC2=true;
              this.CC3=false;
              this.CC4= false;
              this.CC5=false;
              this.CC6=true;
          }
          this.cc1=true;
          this.cc2=false;
          this.cc3=false;





          form.delivery_scope=this.oneclass.delivery_scope;
          if(this.oneclass.delivery_scope==9){
              this.TB1=true;
              this.TB2=false;
              this.typemt=true;
              if(this.oneclass.media_type==2){
                  this.TB1=false;
                  this.TB2=true;
              }
              this.cc1=false;
              this.cc2=true;
              this.cc3=false;


              this.BB9=false;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;

              this.BB109=true;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(this.oneclass.delivery_scope==10){
              this.typemt=false;
              this.TB1=true;
              this.TB2=false;
              this.cc1=false;
              this.cc2=false;
              this.cc3=true;
              this.BB9=true;
              this.BB10=false;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;

              this.BB109=false;
              this.BB110=true;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(this.oneclass.delivery_scope==11){
              this.typemt=false;
              this.TB1=true;
              this.TB2=false;
              this.cc1=false;
              this.cc2=false;
              this.cc3=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=false;
              this.BB12=true;
              this.BB13=true;

              this.BB109=false;
              this.BB110=false;
              this.BB111=true;
              this.BB112=false;
              this.BB113=false;
          }else if(this.oneclass.delivery_scope==12){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=false;
              this.BB13=true;

              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=true;
              this.BB113=false;
          }else if(this.oneclass.delivery_scope==13){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=false;

              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=true;

          }else if(this.oneclass.delivery_scope==1){
              this.BB1=false;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB101=true;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;

          }else if(this.oneclass.delivery_scope==2){
              this.BB1=true;
              this.BB2=false;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB101=false;
              this.BB102=true;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;
          }else if(this.oneclass.delivery_scope==3){
              this.BB1=true;
              this.BB2=true;
              this.BB3=false;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=true;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;
          }else if(this.oneclass.delivery_scope==4){
              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=false;
              this.BB5=true;
              this.BB6=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=true;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;
          }else if(this.oneclass.delivery_scope==5){
              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=false;
              this.BB6=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=true;
              this.BB106=false;
              this.typemt=false;
              this.tfcs=true;
          }else if(this.oneclass.delivery_scope==6){
              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=false;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=true;
              this.typemt=false;
          }else if(this.oneclass.delivery_scope==7){
              this.BB7=false;
              this.BB8=true;
              this.BB107=true;
              this.BB108=false;
              this.typetplj=false;
          }else if(this.oneclass.delivery_scope==8){
              this.BB7=true;
              this.BB8=false;
              this.BB107=false;
              this.BB108=true;
              this.typetplj=true;
          }




          console.info("defaultposter===="+this.oneclass.defaultposter);
          form.defaultposter=this.oneclass.defaultposter;
          if(this.oneclass.industry_classification!=null && this.oneclass.industry_classification!="") {
              form.industry_classification=this.oneclass.industry_classification.split(",");

      }
          form.media_type=this.oneclass.media_type;

          if(this.oneclass.picture!=null && this.oneclass.picture!="") {
              if(this.oneclass.media_type==2){
                  form.showVideoPath = "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+this.oneclass.picture;
                  form.picture=this.oneclass.picture;
              }else{
              form.picture=this.oneclass.picture;
              this.fileList = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + this.oneclass.picture}]
              }
          }
          form.open_browser=this.oneclass.open_browser;
          form.img_url=this.oneclass.img_url;
          form.screen=this.oneclass.screen;
          form.dateRange=[this.oneclass.start_time,this.oneclass.end_time];
          this.form = form;
      }else{

        this.fileList=[];
        let form = {};
        form.industry_classification=[];
        this.form = form;
       // this.form = {};
        //this.form.industry_classification=[];
        this.formEdit = true;
        this.typeone = false;
            this.typetwo = false;
            this.typethree = false;
      }
    },
      changeHandler(value) {
          if(value==1){
              this.TB1=true;
              this.TB2=false;
          }else{
              this.TB1=false;
              this.TB2=true;
          }
      },
      //上传前回调
      beforeUploadVideo(file) {
          var fileSize = file.size / 1024 / 1024 < 10;
          if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
              this.$notify.warning({
                  title: '警告',
                  message: '请上传正确的视频格式'
              })
              return false;
          }
          if (!fileSize) {
              this.$notify.warning({
                  title: '警告',
                  message: '视频大小不能超过10MB'
              })
              return false;
          }
          this.isShowUploadVideo = false;
      },
      //进度条
      uploadVideoProcess(event, file, fileList) {
          this.videoFlag = true;
          this.videoUploadPercent = file.percentage.toFixed(0) * 1;
      },
      //上传成功回调
      handleVideoSuccess(res, file) {
          this.isShowUploadVideo = true;
          this.videoFlag = false;
          this.videoUploadPercent = 0;

          //前台上传地址
        /**  if (file.status == 'success' ) {
             this.form.showVideoPath = file.url;;
          } else {
              this.$notify.warning({
                  title: '警告',
                  message: '上传失败，请重新上传'
              })
        }**/
          //后台上传地址
          if (res.code == 200) {
              //this.form.showVideoPath = "https://szqykj-1307293036.cos.ap-guangzhou.myqcloud.com/"+res.url;
              this.form.picture=res.url;
          } else {
              this.$notify.warning({
                  title: '警告',
                  message: res.Message
              })
          }
      },

      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 2
          if(size > 2) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于2M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },
      // 文件超出个数限制时的钩子
      handleExceed(files, fileList) {

      },
      // 文件列表移除文件时的钩子
      handleRemove(file, fileList) {
          this.form.picture ="";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview(file) {
          console.log("url==="+file.url);
          this.form.picture = file.url;
          this.dialogVisible = true;
      },
      showToggle(val){
        this.form.target_delivery=val;
        this.tfcs=false;
        if(val==1){
            this.TB1=true;
            this.TB2=false;
            this.typemt=false;
            this.typetplj=true;
            this.typeone = true;
            this.typetwo = false;
            this.typethree = false;
            this.typegg=true;
            this.CC1=false;
            this.CC2=true;
                this.CC3=true;
                this.CC4= true;
                this.CC5=false;
                this.CC6=false;




        }else if(val==2){
            this.TB1=true;
            this.TB2=false;
    this.typemt=false;
            this.typetplj=true;
            this.typetwo = true;
            this.typeone = false;
            this.typethree = false;
            this.typegg=false;
    this.CC1=true;
            this.CC2=false;
            this.CC3=true;
            this.CC4= false;
            this.CC5=true;
            this.CC6=false;
        }else if(val==3){
            this.TB1=true;
            this.TB2=false;
              this.typetplj=false;
            this.typethree = true;
            this.typetwo = false;
            this.typeone = false;
            this.typegg=true;
              this.CC1=true;
            this.CC2=true;
            this.CC3=false;
            this.CC4= false;
            this.CC5=false;
            this.CC6=true;
        }
          this.cc1=true;
              this.cc2=false;
              this.cc3=false;

      },
      showToggle2(val){
          this.form.delivery_scope=val;
          this.cc1=true;
          this.cc2=false;
          this.cc3=false;
          this.tfcs=false;
          if(val==9){
              this.TB1=true;
              this.TB2=false;
              if(this.form.media_type==2){
                  this.TB1=false;
                  this.TB2=true;
              }
            this.typemt=true;
              this.cc1=false;
              this.cc2=true;
              this.cc3=false;

              this.BB9=false;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;

              this.BB109=true;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;

              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB7=true;
              this.BB8=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.BB107=false;
              this.BB108=false;

          }else if(val==10){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.cc1=false;
              this.cc2=false;
              this.cc3=true;

              this.BB9=true;
              this.BB10=false;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;

              this.BB109=false;
              this.BB110=true;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;


              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB7=true;
              this.BB8=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.BB107=false;
              this.BB108=false;

          }else if(val==11){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.cc1=false;
              this.cc2=false;
              this.cc3=true;

              this.BB9=true;
              this.BB10=true;
              this.BB11=false;
              this.BB12=true;
              this.BB13=true;

              this.BB109=false;
              this.BB110=false;
              this.BB111=true;
              this.BB112=false;
              this.BB113=false;


              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB7=true;
              this.BB8=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.BB107=false;
              this.BB108=false;

          }else if(val==12){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=false;
              this.BB13=true;

              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=true;
              this.BB113=false;


              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB7=true;
              this.BB8=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.BB107=false;
              this.BB108=false;

          }else if(val==13){
              this.TB1=true;
              this.TB2=false;
              this.typemt=false;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=false;

              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=true;

              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB7=true;
              this.BB8=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.BB107=false;
              this.BB108=false;

          }else if(val==1){
            this.BB1=false;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB101=true;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;


              this.BB7=true;
              this.BB8=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB107=false;
              this.BB108=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;

          }else if(val==2){
              this.BB1=true;
              this.BB2=false;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB101=false;
              this.BB102=true;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;


              this.BB7=true;
              this.BB8=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB107=false;
              this.BB108=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(val==3){
              this.BB1=true;
              this.BB2=true;
              this.BB3=false;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=true;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;


              this.BB7=true;
              this.BB8=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB107=false;
              this.BB108=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(val==4){
              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=false;
              this.BB5=true;
              this.BB6=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=true;
              this.BB105=false;
              this.BB106=false;
              this.typemt=false;


              this.BB7=true;
              this.BB8=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB107=false;
              this.BB108=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(val==5){
              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=false;
              this.BB6=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=true;
              this.BB106=false;
              this.typemt=false;
              this.tfcs=true;
              this.BB7=true;
              this.BB8=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB107=false;
              this.BB108=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(val==6){
              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=false;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=true;
              this.typemt=false;

              this.BB7=true;
              this.BB8=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB107=false;
              this.BB108=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(val==7){
              this.BB7=false;
              this.BB8=true;
              this.BB107=true;
              this.BB108=false;
              this.typetplj=false;

              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }else if(val==8){
              this.BB7=true;
              this.BB8=false;
              this.BB107=false;
              this.BB108=true;
              this.typetplj=true;


              this.BB1=true;
              this.BB2=true;
              this.BB3=true;
              this.BB4=true;
              this.BB5=true;
              this.BB6=true;
              this.BB9=true;
              this.BB10=true;
              this.BB11=true;
              this.BB12=true;
              this.BB13=true;
              this.BB101=false;
              this.BB102=false;
              this.BB103=false;
              this.BB104=false;
              this.BB105=false;
              this.BB106=false;
              this.BB109=false;
              this.BB110=false;
              this.BB111=false;
              this.BB112=false;
              this.BB113=false;
          }

      },
      dateConversion(value) {
          if (value != null && value != "") {
              var d = new Date(value);
              //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
              var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              console.info("===========date=========" + date);
              return date;
          }else{
              return "";
          }
      },
      currentSel(val) {
          if (this.oneclass.id) {
              this.form.city = "";
          }
          this.typeOptions2=[];
          var formData2 = new FormData() // 声明一个FormData对象

          formData2.append('type','city')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions2=data;
          });
      },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            if (this.oneclass.id) {
                this.loading = true;
                agentService.savePoster({
                    ...this.form,
                    agentid: util.cookies.get('agentid'),
                    id: this.oneclass.id,
                    xt_id:util.cookies.get('xt_id'),
                    start_time: this.dateConversion(this.form.dateRange[0]),
                    end_time: this.dateConversion(this.form.dateRange[1])
                })
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });
            }else{
                this.loading = true;
                agentService.savePoster({
                    ...this.form,
                    agentid: util.cookies.get('agentid'),
                    xt_id:util.cookies.get('xt_id'),
                    start_time: this.dateConversion(this.form.dateRange[0]),
                    end_time: this.dateConversion(this.form.dateRange[1])
                })
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });
            }

        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

